import React, { useState, useEffect } from 'react';

import ModalWarn from '../../Components/Modal/Warn/index'
import UnitMigration from '../../Components/UnitMigration'

export default function MigrationBetweenUnits(props) {
    const [ loading, setLoading] = useState(false);
    const [ loadingRegionalManager, setLoadingRegionalManager ] = useState(false);
    const [ loadingAttendant, setLoadingAttendant ] = useState(false);
    const [ migrated, setMigrated ] = useState(false);
    const [ originalUnit, setOriginalUnit ] = useState({
        organCode: '',
        unitCode: '',
        unitName: '',
        state: '',
        street: '',
        number: '',
        city: '',
        neighborhood: '',
        addressComplement: ''
    });
    const [ unidadeOptions, setUnidadeOptions ] = useState([]);
    const [ modalError, setModalError ] = useState(false);
    const [ successMsg, setSuccessMsg ] = useState('');
    const [ messageError, setMessageError ] = useState('');
    const [ modalConfirmVisible, setModalConfirmVisible ] = useState(false);
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    const [ userListRegionalManager, setUserListRegionalManager ] = useState([]);    
    const [ pageOptions, setPageOptions ] = useState([]);
    const [ page, setPage ] = useState({
        label: "1", value: "1"
    });
    const [ totalFilter, setTotalFilter ] = useState("0");
    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });

    const [ userListAttendant, setUserListAttendant ] = useState([]);
    const [ pageOptionsAttendant, setPageOptionsAttendant ] = useState([]);
    const [ pageAttendant, setPageAttendant ] = useState({
        label: "1", value: "1"
    });
    const [ totalFilterAttendant, setTotalFilterAttendant ] = useState("0");
    const [ rangePagesAttendant, setRangePagesAttendant ] = useState({
        label: "10", value: "10"
    });
    
    useEffect(() => {   
        setOriginalUnit(props.location.state?.originalUnit);      
        loadUnidadeListOptions();
        onChangePaginationConfigRegionalManager(rangePages, null, true)
        onChangePaginationConfigAttendant(rangePagesAttendant, null, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function loadUnidadeListOptions() {
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                codigo_orgao: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_orgao : ""
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaUnidadesPorOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {

                    var unidadesList = [];
                    var obj = {};

                    data.forEach((unidade) => {
                        obj = {
                            value: unidade.CODIGO_UNIDADE,
                            label: unidade.NOME_UNIDADE
                        }

                        unidadesList.push(obj);
                    });

                    setUnidadeOptions(unidadesList);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setModalError(true);
                        setMessageError(data.message)
                    } else {
                        setModalError(true);
                        setMessageError('Houve algum problema no servidor.');
                    }
                    //setLoading(false);
                });
            } 
            else 
            if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoading(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                console.log('Error request to /gestao/listaUnidadesPorOrgao');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    const onChangePaginationConfigRegionalManager = async (ranPag, pag, isRanPag) => {
        setMessageError(undefined);
        setLoadingRegionalManager(true);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_unidade: props.location.state?.originalUnit.unitCode,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/listaGestoresRegionaisAssociadosAUnidade`,
                    requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptions(list);
                        if(isRanPag){
                            setPage({label: "1", value: "1"});
                        }
                        setUserListRegionalManager(data.usuarios);
                        setTotalFilter(data.total);
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            setMessageError(data.message)
                        } else {
                            setMessageError('Houve algum problema no servidor.');
                        }
                        //setLoading(false);
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                    setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                    setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                    setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    console.log('Request error in gestao/listaGestoresRegionaisAssociadosAUnidade BackendBalcao');
                }
                setLoadingRegionalManager(false)
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
                setLoadingRegionalManager(false)
            });
    };

    const onChangePaginationConfigAttendant = async (ranPag, pag, isRanPag) => {
        setMessageError(undefined);
        setLoadingAttendant(true)

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_unidade: props.location.state?.originalUnit.unitCode,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/listaAtendentesAssociadosAUnidade`,
                    requestOptions
            ).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptionsAttendant(list);
                        if(isRanPag){
                            setPageAttendant({label: "1", value: "1"});
                        }
                        setUserListAttendant(data.usuarios);
                        setTotalFilterAttendant(data.total);
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            setMessageError(data.message)
                        } else {
                            setMessageError('Houve algum problema no servidor.');
                        }
                        //setLoading(false);
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                    setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                    setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                    setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    console.log('Request error in gestao/listaAtendentesAssociadosAUnidade BackendBalcao');
                }
                setLoadingAttendant(false)
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
                setLoadingAttendant(false)
            });
    }; 

    const onSubmitMigration = async (destination_unit_code) => {
        setModalError(false);
        setLoading(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                codigo_orgao: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_orgao : "",
                codigo_unidade_origem: originalUnit.unitCode,
                codigo_unidade_destino: destination_unit_code
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/unidade/migracaoEntreUnidades`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {
                    setLoading(false);
                    setMigrated(true);
                    setModalConfirmVisible(false);
                    setSuccessMsg(data.message);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setModalError(true);
                        setMessageError(data.message);
                    } else {
                        // inserir mensagem genérica
                        setModalError(true);
                        setMessageError('Houve algum problema no servidor.');
                    }

                    setLoading(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoading(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoading(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <UnitMigration
                pageTitle='Migração entre Unidades'
                originalUnit={originalUnit}
                unidadeOptions={unidadeOptions}
                buttonMigrationLoading={loading}
                buttonCancelRoute={props.location.state?.returnTo}
                onSubmitMigration={onSubmitMigration}
                modalConfirmVisible={modalConfirmVisible}
                setModalConfirmVisible={setModalConfirmVisible}
                messageModalConfirmVisible={'Deseja realizar a migração de todos os Gestores Regionais e todos os Atendentes da Unidade <strong>"n_unidade_origem"</strong> para a Unidade <strong>"n_unidade_destino"</strong>?'}
                messageModalWarn={'Não existem gestores regionais e atendentes cadastrados na unidade <strong>"n_unidade_origem"</strong>.<br>A migração não será realizada.'}
                setModalError={setModalError}
                modalError={modalError}
                messageError={messageError}
                history={props.history}
                migrated={migrated}
                successMsg={successMsg}

                tableResultListTitle='Gestores regionais vinculados à unidade origem'
                onChangePaginationConfigRegionalManager={onChangePaginationConfigRegionalManager}
                totalFilter={totalFilter}
                searchResult={userListRegionalManager}
                pageOptions={pageOptions}
                setPage={setPage}
                page={page}
                rangePages={rangePages}
                setRangePages={setRangePages}
                loadingRegionalManager={loadingRegionalManager}

                tableResultListTitleAttendant='Atendentes vinculados à unidade origem'
                onChangePaginationConfigAttendant={onChangePaginationConfigAttendant}
                searchResultAttendant={userListAttendant}
                rangePagesAttendant={rangePagesAttendant}
                setRangePagesAttendant={setRangePagesAttendant}
                pageAttendant={pageAttendant}
                setPageAttendant={setPageAttendant}
                totalFilterAttendant={totalFilterAttendant}
                pageOptionsAttendant={pageOptionsAttendant}
                loadingAttendant={loadingAttendant}
            />
        </>
    );
}